import type { IconProps } from './types'

export function QuiverLogo({
  className,
  fill = 'currentColor',
  stroke = 'currentColor',
  height = '32',
  width = '32',
  weight = 'bold',
  detail = 1,
}: IconProps & { weight?: 'bold' | 'normal'; detail?: number }) {
  // `normal` slims the solid quiver to sit beside a font-normal wordmark — it
  // compresses the glyph horizontally around its center (x=24). Dial the 0.8 to
  // taste: lower = lighter/thinner, 1 = the original bold mark.
  const slim = 0.8
  const transform =
    weight === 'normal'
      ? `rotate(-19 24 24) translate(24 0) scale(${slim} 1) translate(-24 0)`
      : 'rotate(-19 24 24)'
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="15 6 27 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform={transform}>
        <path
          d="M21 18 Q24 16 27 18 Q28 26 27 38 Q24 40 21 38 Q20 26 21 18 Z"
          fill={fill}
        />
        <path
          d="M22 19 L22 21"
          stroke={stroke}
          strokeWidth="0.25"
          strokeOpacity={detail}
          fill="none"
        />
        <path
          d="M24 19 L24 21"
          stroke={stroke}
          strokeWidth="0.25"
          strokeOpacity={detail}
          fill="none"
        />
        <path
          d="M26 19 L26 21"
          stroke={stroke}
          strokeWidth="0.25"
          strokeOpacity={detail}
          fill="none"
        />
        <path
          d="M21 18 L21 8 L19 10 L21 8 L23 10 L21 8 L20 9 L21 8 L22 9"
          fill={fill}
        />
        <path
          d="M23 18 L23 6 L21 8 L23 6 L25 8 L23 6 L22 7 L23 6 L24 7"
          fill={fill}
        />
        <path
          d="M25 18 L25 8 L23 10 L25 8 L27 10 L25 8 L24 9 L25 8 L26 9"
          fill={fill}
        />
        <path
          d="M27 18 L27 8 L25 10 L27 8 L29 10 L27 8 L26 9 L27 8 L28 9"
          fill={fill}
        />
        <path
          d="M22 35 L22 37"
          stroke={stroke}
          strokeWidth="0.25"
          strokeOpacity={detail}
          fill="none"
        />
        <path
          d="M24 35 L24 37"
          stroke={stroke}
          strokeWidth="0.25"
          strokeOpacity={detail}
          fill="none"
        />
        <path
          d="M26 35 L26 37"
          stroke={stroke}
          strokeWidth="0.25"
          strokeOpacity={detail}
          fill="none"
        />
      </g>
      {/* <path
        d="M25 20 L25 30 Q22 32 24 37"
        // d="M25 20 L20 30 Q22 32 24 37"
        stroke="rgb(79 70 229)"
        // stroke={stroke}
        strokeWidth="0.25"
        fill="none"
      /> */}
    </svg>
  )
}
